export default __webpack_public_path__ + "static/media/screen4.d98d8c56.png";